<template>
  <div class="mt-5">
    <div v-if="open_panel">
      <v-card class="brown lighten-5" :loading="loading" :disabled="loading">
        <v-card-title>
          <span v-if="mode === 'add'">{{
            $t("registration.add_subject")
          }}</span>
          <span v-if="mode === 'change'">{{
            $t("registration.change_subject")
          }}</span>
          <span v-if="mode === 'remove'">{{
            $t("registration.withdraw_subject")
          }}</span>
        </v-card-title>
        <v-card-text class="pa-1 pa-sm-3 pa-xl-6">
          <credit-box
            :summary_credit="summary_credit"
            :max_credit="max_credit"
            :min_credit="min_credit"
          ></credit-box>
          <div class="mt-5" v-if="mode === 'remove' || mode === 'change'">
            <v-divider class="mb-5 mt-3"></v-divider>
            <h3 class="mb-2 red--text">
              <span v-if="mode === 'change'">{{
                $t("registration.select_subject_to_change_out")
              }}</span>
              <span v-if="mode === 'remove'">{{
                $t("registration.select_subject_to_withdraw")
              }}</span>
            </h3>
            <v-select
              class="subject-select mx-auto"
              outlined
              dense
              hide-details
              v-model="to_remove_subject_id"
              :items="no_dup_registering_subject_list"
              :item-text="
                (item) => item.subject_id + ' - ' + item.subject_ename
              "
              :item-value="(item) => item.subject_id"
              v-on:change="clear_adding_subject_id()"
            ></v-select>
          </div>

          <!-- ------------------------------------------------------- -->
          <h3 class="mt-5 light-green--text text--darken-2">
            <span v-if="mode === 'change'">{{
              $t("registration.select_subject_to_change_in")
            }}</span>
            <span v-if="mode === 'add'">{{
              $t("registration.select_subject_to_add")
            }}</span>
          </h3>
          <v-simple-table
            dense
            class="mt-2"
            v-if="mode === 'add' || mode === 'change'"
          >
            <template v-slot:default>
              <thead>
                <!-- Table Header -->
                <tr>
                  <th class="text-center">
                    {{ $t("pre_regis_add_subject.delete") }}
                  </th>
                  <th class="text-center subject-id">
                    {{ $t("pre_regis_add_subject.subject_id") }}
                  </th>
                  <th class="text-center subject-name">
                    {{ $t("pre_regis_add_subject.subject_name") }}
                  </th>
                  <th class="text-center">
                    {{ $t("pre_regis_add_subject.credit") }}
                  </th>
                  <th class="text-center section">
                    {{ $t("pre_regis_add_subject.section") }}
                  </th>
                  <th class="text-center subject-type">
                    {{ $t("pre_regis_add_subject.type") }}
                  </th>
                  <th class="text-center">
                    {{ $t("pre_regis_add_subject.class_exam_timetable") }}
                  </th>
                  <th class="text-center">
                    {{ $t("pre_regis_add_subject.limit") }}
                  </th>
                  <th class="text-center last-cell">
                    {{ $t("regis_add_subject.number_of_people_registered_x") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- --------------------------------------------------------------- -->
                <!-- Add subject -->
                <tr :style="subject_adding_color">
                  <td>
                    <v-btn
                      v-if="adding_subject_id.length === 8"
                      icon
                      v-on:click="clear_adding_subject_id()"
                    >
                      <v-icon color="red">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-text-field
                      @input="search_subject()"
                      class="ma-1"
                      outlined
                      dense
                      hide-details
                      v-if="!(mode === 'change' && !to_remove_subject_id)"
                      v-model="adding_subject_id"
                      :disabled="searched_subjects !== null"
                    ></v-text-field>
                  </td>
                  <td>
                    <div v-if="has_primary">
                      <a class="subject-link" @click="openSubjectDialog(all_primary[0].subject_id)">
                        {{ all_primary[0].subject_ename }}
                      </a>
                    </div>
                  </td>
                  <td>
                    <div v-if="has_primary">
                      <class-hour-text
                        show_lect_or_prac
                        :item="all_primary[0]"
                      ></class-hour-text>
                    </div>
                  </td>
                  <td>
                    <div v-if="has_primary">
                      <v-select
                        v-model="selected_primary_subject_section"
                        dense
                        hide-details
                        class="ma-1"
                        outlined
                        :items="all_primary"
                        :item-text="
                          (item) =>
                            item.section +
                            (item.has_same_section
                              ? ' (' +
                                inlineTranslator({
                                  en: item.curr2_ename,
                                  th: item.curr2_tname,
                                }) +
                                ')'
                              : '')
                        "
                        :item-value="(item) => item"
                        @change="(e) => select_section(e)"
                      ></v-select>
                    </div>
                  </td>
                  <td>
                    <div
                      v-if="has_primary && all_primary[0].subject_type !== 'T'"
                    >
                      <v-select
                        v-model="selected_subject_type"
                        dense
                        hide-details
                        class="ma-1"
                        outlined
                        :items="subject_type_list"
                        :item-value="(item) => item"
                      ></v-select>
                    </div>
                    <div v-else-if="has_primary">Cr</div>
                  </td>
                  <td>
                    <div
                      class="full-width"
                      v-if="has_primary && selected_primary_subject_section"
                    >
                      <teach-and-exam-time
                        :item="selected_primary_subject_section"
                        :show_timeslot_dropdown="false"
                      ></teach-and-exam-time>
                    </div>
                  </td>
                  <td>
                    <div v-if="selected_primary_subject_section">
                      {{
                        selected_primary_subject_section.LIMIT != "0"
                          ? selected_primary_subject_section.LIMIT
                          : "-"
                      }}
                    </div>
                  </td>
                  <td class="last-cell">
                    <div v-if="selected_primary_subject_section">
                      {{ selected_primary_subject_section.COUNT }}
                    </div>
                  </td>
                </tr>
                <!-- Add subject Practice -->
                <tr
                  :style="subject_adding_color"
                  v-if="is_has_theory_and_practice"
                >
                  <td></td>
                  <td>{{ $t("pre_regis_add_subject.practice") }}</td>
                  <td>
                    <div v-if="has_secondary">
                      <a class="subject-link" @click="openSubjectDialog(all_secondary[0].subject_id)">
                        {{ all_secondary[0].subject_ename }}
                      </a>
                    </div>
                  </td>
                  <td>
                    <div v-if="has_secondary">
                      <class-hour-text
                        show_lect_or_prac
                        :item="all_secondary[0]"
                      ></class-hour-text>
                    </div>
                  </td>
                  <td>
                    <div
                      v-if="
                        has_secondary &&
                        is_lock_practice_section &&
                        selected_secondary_subject_section
                      "
                    >
                      {{ selected_secondary_subject_section.section }}
                    </div>
                    <div v-if="has_secondary && !is_lock_practice_section">
                      <v-select
                        v-model="selected_secondary_subject_section"
                        dense
                        hide-details
                        class="ma-1"
                        outlined
                        :items="all_secondary"
                        :item-text="
                          (item) =>
                            item.section +
                            (item.has_same_section
                              ? ' (' +
                                inlineTranslator({
                                  en: item.curr2_ename,
                                  th: item.curr2_tname,
                                }) +
                                ')'
                              : '')
                        "
                        :item-value="(item) => item"
                        @change="(e) => select_section(e, true)"
                      ></v-select>
                    </div>
                  </td>
                  <td>-</td>
                  <td>
                    <div
                      class="full-width"
                      v-if="has_secondary && selected_secondary_subject_section"
                    >
                      <teach-and-exam-time
                        :item="selected_secondary_subject_section"
                        :show_timeslot_dropdown="false"
                      ></teach-and-exam-time>
                    </div>
                  </td>
                  <td>
                    <div v-if="selected_secondary_subject_section">
                      {{
                        selected_secondary_subject_section.LIMIT != "0"
                          ? selected_secondary_subject_section.LIMIT
                          : "-"
                      }}
                    </div>
                  </td>
                  <td class="last-cell">
                    <div v-if="selected_secondary_subject_section">
                      {{ selected_secondary_subject_section.COUNT }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- ------------------------------------------------------- -->
        </v-card-text>
      </v-card>
    </div>

    <div class="text-right mt-1" v-if="open_panel">
      {{ $t("registration.subject_type_description") }}
    </div>

    <div>
      <v-btn
        class="ml-2 green white--text"
        v-if="!open_panel && (change_period || bypass)"
        @click="add()"
        >{{ $t("registration.add") }}</v-btn
      >
      <v-btn
        class="ml-2 orange white--text"
        v-if="!open_panel && (change_period || bypass)"
        @click="change()"
        >{{ $t("registration.change") }}</v-btn
      >
      <v-btn
        class="ml-2 red white--text"
        v-if="!open_panel && (withdraw_period || change_period || bypass)"
        @click="remove()"
        >{{ $t("registration.withdraw") }}</v-btn
      >
      <v-btn
        class="ml-2 light-blue darken-3 white--text"
        v-if="open_panel"
        @click="confirm_dialog = true"
        :disabled="!can_confirm"
        >{{ $t("registration.continuous") }}</v-btn
      >
      <v-btn class="ml-2 red white--text" v-if="open_panel" @click="cancel()">{{
        $t("registration.cancel")
      }}</v-btn>
    </div>

    <v-dialog v-model="confirm_dialog" :loading="loading" width="500">
      <v-card>
        <v-card-title>{{ $t("registration.confirm_title") }}</v-card-title>
        <v-card-text>
          {{ $t("registration.confirm_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="confirm()" class="ml-2 green white--text">
            {{ $t("registration.confirm") }}
          </v-btn>
          <v-btn
            @click="confirm_dialog = false"
            class="ml-2 orange white--text"
          >
            {{ $t("registration.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <subject-dialog ref="subject_dialog" :level-id="level_id" />
  </div>
</template>

<script>
import { computed_subject_list } from "@/helper/registration";
import { check_integrity_time } from "@/helper/registration";
import CreditBox from "./CreditBox.vue";
import RegistrationProvider from "@/services/registration.provider.js";
const RegistrationService = new RegistrationProvider();
import ClassHourText from "./ClassHourText.vue";
import TeachAndExamTime from "./TeachAndExamTime.vue";
import {
  objectTranslatorLowerCase,
  inlineTranslator,
} from "@/helper/translator";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";

export default {
  name: "AddChangeDelete",
  props: {
    computed_registering_subject_list: {
      type: Array,
    },
    getRegisResult: {
      type: Function,
    },
    transactions_fetched: {
      type: Boolean,
    },
    getRegisTransaction: {
      type: Function,
    },
    change_period: {
      type: Boolean,
      default: false,
    },
    withdraw_period: {
      type: Boolean,
      default: false,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
    bypass: {
      type: Boolean,
      default: null,
    },
    level_id: {
      type: Number,
      default: null,
    },
    sub_level_id: {
      type: Number,
      default: null,
    },
  },
  components: {
    ClassHourText,
    TeachAndExamTime,
    CreditBox,
    SubjectDialog,
  },
  data: () => ({
    loading: false,
    open_panel: false,
    mode: "", // add, change, remove
    subject_adding_status: 0, // 0 คือยังไม่ได้กรอก หรือยังไม่ได้เลือกเซค, 1 คือ ผ่านเงื่อนไข, 2 คือ ไม่ผ่าน
    adding_subject_id: "",
    searched_subjects: null,
    selected_primary_subject_section: null,
    selected_secondary_subject_section: null,
    to_remove_subject_id: null,

    confirm_dialog: false,

    subject_type_list: ["Cr", "Ad", "Tr", "Nc"],
    selected_subject_type: "Cr",

    min_credit: null,
    max_credit: null,
  }),
  computed: {
    is_lock_practice_section() {
      if (!this.selected_primary_subject_section) return true;
      if (this.selected_primary_subject_section.sec_pair !== null) return true;
      return false;
    },

    locked_section_practice() {
      if (
        this.is_lock_practice_section &&
        this.selected_primary_subject_section
      )
        return this.all_secondary.find(
          (item) =>
            item.section === this.selected_primary_subject_section.sec_pair
        );
      return null;
    },
    can_confirm() {
      if (!this.bypass) {
        if (
          (!this.min_credit && !this.max_credit) ||
          this.summary_credit > this.max_credit ||
          this.summary_credit < this.min_credit
        )
          return false;
      }
      if (this.mode === "add" && this.subject_adding_status === 1) return true;
      if (
        this.mode === "remove" &&
        this.to_remove_subject_id &&
        this.computed_registering_subject_list.length > 1
      )
        return true;
      if (
        this.mode === "change" &&
        this.subject_adding_status === 1 &&
        this.to_remove_subject_id
      )
        return true;
      return false;
    },
    no_dup_registering_subject_list() {
      let subject_ids = [];
      return this.computed_registering_subject_list.filter((item) => {
        if (subject_ids.includes(item.subject_id)) return false;
        subject_ids.push(item.subject_id);
        return true;
      });
    },
    to_remove_subject_object() {
      if (this.to_remove_subject_id) {
        const temp = this.computed_registering_subject_list.filter(
          (item) => item.subject_id === this.to_remove_subject_id
        );

        if (temp.length > 1) {
          return this.computed_registering_subject_list.find(
            (item) =>
              item.subject_id === this.to_remove_subject_id &&
              item.lect_or_prac === "ท"
          );
        } else if (temp.length === 1) {
          return temp[0];
        }
      }
      return null;
    },
    summary_credit() {
      const temp = this.computed_registering_subject_list.map((item) => {
        const same_subject = this.computed_registering_subject_list.filter(
          (item_2) => item_2.subject_id === item.subject_id
        );
        if (same_subject.length > 1) {
          return { ...item, has_pair: true };
        } else return { ...item, has_pair: false };
      });

      let sum = temp.reduce((sum, item) => {
        if (item.has_pair && item.lect_or_prac === "ป") return sum;

        // Nc ไม่คิดเครติด
        if (item.subject_type === "Nc") return sum;

        return sum + parseInt(item.credit);
      }, 0);

      if (this.mode === "add" && this.selected_primary_subject_section) {
        // Nc ไม่คิดเครติด
        if (this.selected_subject_type !== "Nc")
          sum += parseInt(this.selected_primary_subject_section.credit);
      }

      if (this.mode === "remove" && this.to_remove_subject_object) {
        // Nc ไม่คิดเครติด
        if (this.to_remove_subject_object.subject_type !== "Nc")
          sum -= parseInt(this.to_remove_subject_object.credit);
      }

      if (this.mode === "change" && this.to_remove_subject_object) {
        // Nc ไม่คิดเครติด
        if (this.to_remove_subject_object.subject_type !== "Nc")
          sum -= parseInt(this.to_remove_subject_object.credit);
      }

      if (this.mode === "change" && this.selected_primary_subject_section) {
        // Nc ไม่คิดเครติด
        if (this.selected_subject_type !== "Nc")
          sum += parseInt(this.selected_primary_subject_section.credit);
      }

      return sum;
    },
    // จะแปลงพวกวันเรียน วันสอบ ให้อยู่ในตัวแปรที่เหมาะสมต่อการแสดง
    computed_searched_subjects() {
      if (!this.searched_subjects) return null;
      return computed_subject_list(this.searched_subjects);
    },
    subject_adding_color() {
      if (this.mode === "change" && !this.to_remove_subject_id)
        return "background-color: #ccc";
      if (this.subject_adding_status === 1) return "background-color: #dbffb8";
      if (this.subject_adding_status === 2) return "background-color: #ffcfcc";
      return "background-color: #fff1d9";
    },
    // จะเป็น true ถ้ากำลัง add วิชา และมีโปรแกรมจับคู่ปฏิบัติเข้ามา
    is_has_theory_and_practice() {
      if (!this.computed_searched_subjects) return false;
      let has_theory = false;
      let has_practice = false;
      this.computed_searched_subjects.map((item) => {
        if (item.lect_or_prac === "ท") has_theory = true;
        if (item.lect_or_prac === "ป") has_practice = true;
      });
      return has_theory && has_practice;
    },

    all_primary() {
      if (this.computed_searched_subjects === null) return null;
      if (this.is_has_theory_and_practice)
        return this.computed_searched_subjects.filter(
          (item) => item.lect_or_prac === "ท"
        );
      else return this.computed_searched_subjects;
    },

    all_secondary() {
      if (this.computed_searched_subjects === null) return null;
      if (!this.is_has_theory_and_practice) return null;
      if (!this.selected_primary_subject_section) return null;
      return this.computed_searched_subjects.filter(
        (item) =>
          item.lect_or_prac === "ป" &&
          (item.sec_pair === this.selected_primary_subject_section.section ||
            item.sec_pair === null)
      );
    },

    has_primary() {
      return this.all_primary && this.all_primary[0];
    },
    has_secondary() {
      return this.all_secondary && this.all_secondary[0];
    },
  },
  methods: {
    objectTranslatorLowerCase,
    inlineTranslator,
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
    clear_adding_subject_id() {
      this.adding_subject_id = "";
      this.searched_subjects = null;
      this.subject_adding_status = 0;
      this.selected_primary_subject_section = null;
      this.selected_secondary_subject_section = null;
      this.selected_subject_type = "Cr";
    },
    add() {
      this.open_panel = true;
      this.mode = "add";
    },
    change() {
      this.open_panel = true;
      this.to_remove_subject_id = null;
      this.mode = "change";
    },
    remove() {
      this.open_panel = true;
      this.to_remove_subject_id = null;
      this.mode = "remove";
    },
    cancel() {
      this.open_panel = false;
      this.mode = "";
      this.adding_subject_id = "";
      this.searched_subjects = null;
      this.subject_adding_status = 0;
      this.selected_primary_subject_section = null;
      this.selected_secondary_subject_section = null;
      this.to_remove_subject_id = null;
      this.confirm_dialog = false;
      this.selected_subject_type = "Cr";
    },
    async confirm() {
      if (this.can_confirm) {
        this.loading = true;
        this.confirm_dialog = false;

        if (this.mode === "add") {
          const teach_table_id_list = [];
          const subject_type_list = [];
          const credit_list = [];
          if (this.selected_primary_subject_section) {
            teach_table_id_list.push(
              this.selected_primary_subject_section.teach_table_id
            );
            subject_type_list.push(this.selected_subject_type);
            credit_list.push(this.selected_primary_subject_section.credit);
          }
          if (this.selected_secondary_subject_section) {
            teach_table_id_list.push(
              this.selected_secondary_subject_section.teach_table_id
            );
            subject_type_list.push(this.selected_subject_type);
            credit_list.push(this.selected_secondary_subject_section.credit);
          }

          const data = await RegistrationService.regisAdd({
            student_id: this.student_id,
            year: this.year,
            semester: this.semester,
            level_id: this.level_id,
            teach_table_id_list,
            sub_level_id: this.sub_level_id,
            subject_type_list,
            credit_list,
            bypass: this.bypass,
          }).catch((error) => {
            this.loading = false;
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
          });

          if (data && data.status) {
            this.$toasted.success("เพิ่มวิชาสำเร็จ", { duration: 0 });
            await this.getRegisResult();
            if (this.transactions_fetched) await this.getRegisTransaction();
            this.loading = false;
            this.cancel();
          } else if (data && !data.status) {
            this.$toasted.error("เพิ่มวิชาไม่สำเร็จ หรือ วิชานี้เต็มแล้ว ", {
              duration: 0,
            });
            this.loading = false;
          }
        }

        if (this.mode === "change") {
          const new_teach_table_id_list = [];
          const new_subject_type_list = [];
          const new_credit_list = [];
          if (this.selected_primary_subject_section) {
            new_teach_table_id_list.push(
              this.selected_primary_subject_section.teach_table_id
            );
            new_subject_type_list.push(this.selected_subject_type);
            new_credit_list.push(this.selected_primary_subject_section.credit);
          }
          if (this.selected_secondary_subject_section) {
            new_teach_table_id_list.push(
              this.selected_secondary_subject_section.teach_table_id
            );
            new_subject_type_list.push(this.selected_subject_type);
            new_credit_list.push(
              this.selected_secondary_subject_section.credit
            );
          }

          const old_teach_table_id_list = [
            this.to_remove_subject_object.TEACH_TABLE_ID,
          ];

          const data = await RegistrationService.regisChange({
            student_id: this.student_id,
            year: this.year,
            semester: this.semester,
            level_id: this.level_id,
            new_teach_table_id_list,
            old_teach_table_id_list,
            sub_level_id: this.sub_level_id,
            new_subject_type_list,
            new_credit_list,
            bypass: this.bypass,
          }).catch((error) => {
            this.loading = false;
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
          });

          if (data && data.status) {
            this.$toasted.success("เปลี่ยนวิชาสำเร็จ", { duration: 0 });
            await this.getRegisResult();
            if (this.transactions_fetched) await this.getRegisTransaction();
            this.loading = false;
            this.cancel();
          } else if (data && !data.status) {
            this.$toasted.error("เปลี่ยนวิชาไม่สำเร็จ หรือ วิชานี้เต็มแล้ว", {
              duration: 0,
            });
            this.loading = false;
          }
        }

        if (this.mode === "remove") {
          const teach_table_id_list = [
            this.to_remove_subject_object.TEACH_TABLE_ID,
          ];
          const subject_type_list = [this.selected_subject_type];
          const credit_list = [this.to_remove_subject_object.credit];

          const data = await RegistrationService.regisWithdraw({
            student_id: this.student_id,
            year: this.year,
            semester: this.semester,
            level_id: this.level_id,
            teach_table_id_list,
            sub_level_id: this.sub_level_id,
            subject_type_list,
            credit_list,
            bypass: this.bypass,
          }).catch((error) => {
            this.loading = false;
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
          });

          if (data && data.status) {
            this.$toasted.success("ถอนวิชาสำเร็จ", { duration: 0 });
            await this.getRegisResult();
            if (this.transactions_fetched) await this.getRegisTransaction();
            this.loading = false;
            this.cancel();
          } else if (data) {
            this.$toasted.error("ถอนวิชาไม่สำเร็จ", { duration: 0 });
            this.loading = false;
          }
        }
      }
    },
    get_class(item) {
      if (item.has_pair && item.lect_or_prac === "ท") return "no_bottom_line ";
      if (item.has_pair && item.lect_or_prac === "ป") return "no_top_line ";
      return "";
    },

    async search_subject() {
      this.loading = true;
      if (this.adding_subject_id.length === 8) {
        if (
          this.computed_registering_subject_list.filter(
            (item) =>
              item.subject_id === this.adding_subject_id &&
              item.subject_id !== this.to_remove_subject_id
          ).length !== 0
        ) {
          this.$toasted.error(
            this.$t("pre_regis_add_subject.error_in_taking_this_course") +
              this.adding_subject_id +
              ": " +
              this.$t("pre_regis_add_subject.already_in_list"),
            { duration: 0 }
          );
          this.searched_subjects = null;
        } else {
          const data =
            await RegistrationService.getCanRegisterByStudentIdAndSubjectIdX({
              subject_id: this.adding_subject_id,
              student_id: this.student_id,
              year: this.year,
              semester: this.semester,
              bypass: this.bypass,
            });
          if (!data.data || data.data.length === 0) {
            this.$toasted.error(
              this.$t("pre_regis_add_subject.error_in_taking_this_course") +
                this.adding_subject_id +
                ": " +
                this.objectTranslatorLowerCase(data.error, "message"),
              { duration: 0 }
            );
          } else {
            if (
              data.subject_id_grade_not_announce &&
              data.subject_id_grade_not_announce.length > 0
            ) {
              this.subject_id_grade_not_announce =
                data.subject_id_grade_not_announce;
              this.confirm_grade_not_announce_dialog = true;
            }
            this.searched_subjects = data.data;
          }
        }
      }
      this.loading = false;
    },
    async select_section(teach_table_object, is_secondary = false) {
      if (!is_secondary) {
        this.selected_secondary_subject_section = null;
      }

      let cleaned_registering_subject_list =
        this.computed_registering_subject_list;
      if (this.mode === "change")
        cleaned_registering_subject_list =
          cleaned_registering_subject_list.filter(
            (item) => item.subject_id !== this.to_remove_subject_id
          );

      let is_pass_time_condition = false;

      if (!this.is_has_theory_and_practice) {
        is_pass_time_condition = await check_integrity_time(
          this.adding_subject_id,
          cleaned_registering_subject_list,
          teach_table_object
        );
      } else if (
        this.is_has_theory_and_practice &&
        this.selected_secondary_subject_section
      ) {
        is_pass_time_condition = await check_integrity_time(
          this.adding_subject_id,
          cleaned_registering_subject_list,
          teach_table_object,
          this.selected_secondary_subject_section
        );
      } else if (
        this.is_has_theory_and_practice &&
        this.is_lock_practice_section
      ) {
        this.selected_secondary_subject_section = this.locked_section_practice;
        is_pass_time_condition = await check_integrity_time(
          this.adding_subject_id,
          cleaned_registering_subject_list,
          teach_table_object,
          this.locked_section_practice
        );
      }

      if (
        !this.selected_primary_subject_section ||
        (this.is_has_theory_and_practice &&
          !this.selected_secondary_subject_section)
      ) {
        this.subject_adding_status = 0;
      } else if (is_pass_time_condition || this.bypass) {
        this.subject_adding_status = 1;
      } else {
        this.subject_adding_status = 2;
      }
    },
    async get_student_credit() {
      const data = await RegistrationService.getStudentCredit({
        level_id: this.level_id,
        semester: this.semester,
        student_id: this.student_id,
        sub_level_id: this.sub_level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.min_credit = parseInt(data.check_lower_credit);
      this.max_credit = parseInt(data.check_higher_credit);
    },
  },
  created: function () {
    this.get_student_credit();
  },
};
</script>

<style lang="scss" scoped>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}
thead {
  background-color: #ffbd43;
}

thead.pattern {
  background-color: #aaa;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.subject-id {
  min-width: 140px;
  width: 140px;
}

.subject-name {
  min-width: 150px;
}

.section {
  min-width: 80px;
  width: 80px;
}

.subject-type {
  min-width: 110px;
  width: 110px;
}

.subject-select {
  min-width: 50%;
  max-width: max-content;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
